export default {
  // 判断是否打开登录窗口
  profile: {},
  current_region: {},
  article_title: {},
  accessToken: "",
  options: []
};



// WEBPACK FOOTER //
// ./src/store/state.js